// Gemensam Fenny-data för Malmö-sidorna. Trust/pricing/process delas
// över sidorna men varje URL har unik rubrik och kontext för Google.

import type { LandingTrustItem, LandingPriceRow, LandingProcessStep } from "@/components/site/landing/LandingPage";

export const malmoTrust: LandingTrustItem[] = [
  { value: "90+", label: "produktioner sedan 2019" },
  { value: "48 h", label: "från brief till offert" },
  { value: "9.4/10", label: "kundnöjdhet (NPS)" },
  { value: "SE+DK", label: "tvåspråkiga team" },
];

export const malmoProductionPricing: LandingPriceRow[] = [
  { format: "Social-content (paid + organiskt)", scope: "5–10 vertikala klipp, 1 inspelningsdag", price: "40 000–120 000 kr", lead: "2–3 v" },
  { format: "Reklamfilm 15–30 s", scope: "Manus, regi, foto, 1–2 dagar inspelning, grade & ljudmix", price: "150 000–450 000 kr", lead: "4–6 v" },
  { format: "Brand-/imagefilm 60–90 s", scope: "Konceptutveckling, hero-film + cutdowns för paid", price: "250 000–700 000 kr", lead: "5–8 v" },
  { format: "Kundcase / dokumentär", scope: "Intervjuer, b-roll, 2–4 min film", price: "45 000–260 000 kr", lead: "3–5 v" },
  { format: "Employer branding-serie", scope: "Hero + 6–10 medarbetar-snuttar", price: "170 000–500 000 kr", lead: "5–8 v" },
  { format: "Pulse-abonnemang", scope: "Löpande leverans av rörligt — fast månadspris", price: "från 14 995 kr/mån", lead: "Start 10–14 d" },
];

export const malmoProcess: LandingProcessStep[] = [
  { label: "Brief & strategi", duration: "vecka 1", body: "Vi förstår mål, målgrupp och distribution. Offert med fast pris inom 48 h." },
  { label: "Manus & pre-prod", duration: "vecka 2–3", body: "Manus, storyboard, casting, location-scout i Malmö, Lund, Helsingborg eller över Sundet. Skriftligt godkännande innan kamera går igång." },
  { label: "Inspelning", duration: "vecka 3–4", body: "1–3 dagar med fullt crew. Vana vid Öresund-produktioner, tvåspråkiga team och life science-miljöer." },
  { label: "Post & leverans", duration: "vecka 4–6", body: "Klipp, grade, ljudmix, motion. Två revisionsrundor ingår. Versionering på svenska, engelska och danska vid behov." },
];
